import { Routes } from '@angular/router';

export const colListRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./col-list.page').then((m) => m.ColListPage),
  },
];
